(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.controller('FeeUploadController', FeeUploadController);

	FeeUploadController.$inject = ['$scope', '$state', '$rootScope', 'GlobalValues', 'workflowSharedService','BankFeeAndChargesUploadService','entity','DateUtils','Workflow','FileUtil','AlertService','$filter','systemSettings','entityConstants','ScreenLog','globalValue','configurationSetting','$uibModalInstance'];

	function FeeUploadController($scope, $state, $rootScope, GlobalValues, workflowSharedService,BankFeeAndChargesUploadService,entity,DateUtils,Workflow,FileUtil,AlertService,$filter,systemSettings,entityConstants,ScreenLog,globalValue,configurationSetting,$uibModalInstance) {
		var vm = this;
		console.log(vm.bankForCustomerTacDTO);
		vm.globalValues = GlobalValues;
		vm.orgId = vm.globalValues.getOrgId();
		vm.bank = vm.globalValues.getOrganisation();

		vm.clear=clear;
		vm.save=save;
		vm.clicked=false;
		$scope.showButton = false;
		$scope.showApproveRejectButton=false;
		$scope.showDiscardButton = false;
		$scope.showResubmitButton=false;
		
		vm.viewMode=false;
		var minFileSizeinBytes = 0;
		var maxFileSizeinBytes = 500000;
		vm.maximumFileSizeinKB = (configurationSetting != null && configurationSetting != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != null && configurationSetting.maximumFileSizeTermsAndConditionsUpload != undefined && configurationSetting.maximumFileSizeTermsAndConditionsUpload != '') ? parseInt(configurationSetting.maximumFileSizeTermsAndConditionsUpload) : 500000 ;
		vm.minimumFileSizeInKB = 0;
		vm.screenName = entityConstants.ENTITY_SHORT_NAME.BANK_FEES_CHARGES_UPLOAD;
		logScreenAccess();
		function logScreenAccess(){
			ScreenLog.screenLog( vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.EDIT);
		}
		vm.configSettings = globalValue;
		vm.checkBankFeeFile = false;

		vm.maxFileNameLength = (vm.configSettings.uploadedFileNameLength != null && vm.configSettings.uploadedFileNameLength != undefined && vm.configSettings.uploadedFileNameLength != '') ?vm.configSettings.uploadedFileNameLength : 150 ;
		
		if( vm.minimumFileSizeInKB != undefined &&  vm.minimumFileSizeInKB !=null &&  vm.minimumFileSizeInKB  !=''){
			minFileSizeinBytes = vm.minimumFileSizeInKB*1024;
		}
		if( vm.maximumFileSizeinKB != undefined &&  vm.maximumFileSizeinKB !=null &&  vm.maximumFileSizeinKB  !=''){
			
			maxFileSizeinBytes = vm.maximumFileSizeinKB*1024;
			if(vm.maximumFileSizeinKB == 1024){
				vm.showInKB = false;
				vm.bankFeeFileUploadSize = 1;
			}else{
				vm.showInKB = true;
				vm.bankFeeFileUploadSize = vm.maximumFileSizeinKB;
			}
		}
		
		var Extensions = "pdf";
		vm.minDate = new Date();
		vm.minDate.setDate(new Date().getDate() + 1);

		if(systemSettings != null && systemSettings != undefined){
			vm.businessDate  = DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
			vm.businessDatePlusOne =  moment(vm.businessDate).add(1,'days').toDate();
			vm.minDate = angular.copy(vm.businessDatePlusOne);
		}
		
		$scope.showButton = false;

		$scope.showButton = true;
		$scope.showApproveRejectButton = false;
		$scope.showDiscardButton = false;
		$scope.showResubmitButton=false;
		vm.viewMode=false;
		
		vm.tacMasterId = 0;



		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save () {   
			
				if(vm.bankFee != null){
					var fd1 = new FormData();				
					fd1.append('file', vm.bankFee);
					console.log(fd1);
					BankFeeAndChargesUploadService.update(fd1, onSaveSuccess, onSaveError);
				}
		}
		
		function resetValues(){
			vm.clicked = false;

				vm.bankForCustomerTacDTO.enforcingDate = vm.minDate;
				vm.inputBankFee=null;
				vm.bankFee = null;

		}


		function onSaveSuccess (result) {
			$uibModalInstance.close(result);  
		}


		function onSaveError () {

			vm.clicked = false;
		}


		//validate terms and condition 
		$scope.$watch('vm.bankFee', function(value){

			if(value!= undefined && value!=null){
				if(!FileUtil.isFileSizeValid(value.size ,minFileSizeinBytes , maxFileSizeinBytes  )){
					vm.invalidBankFeeSize = true;
					if(vm.showInKB == true){
						vm.invalidBankFeeSizeText = "Maximum of " + vm.bankFeeFileUploadSize +" KB file size is allowed";
					}else{
						vm.invalidBankFeeSizeText = "Maximum of " + vm.bankFeeFileUploadSize +" MB file size is allowed";
					}
					vm.invalidBankFee = false;
					vm.invalidBankFeeName = false;
					vm.bankFee=null;
					angular.element("input[type='file']").val(null);

				}else{
					vm.inputBankFee=vm.bankFee.name;
					vm.invalidBankFeeSize = false;
					vm.invalidBankFee = false;
					vm.invalidBankFeeName = false;
					vm.fileExtension = vm.inputBankFee.substring(vm.bankFee.name.lastIndexOf(".") + 1);
					var fileNameWithoutExtension  =  vm.inputBankFee.substring(0,vm.bankFee.name.lastIndexOf("."));
					//check for extension
					if(!(Extensions == (vm.fileExtension.toLowerCase()))) {
						angular.element("input[type='file']").val(null);
						vm.bankFee=null;
						vm.inputBankFee=null;
						vm.invalidBankFee = true;
						vm.invalidBankFeeSize = false;
						vm.invalidBankFeeName = false;
						vm.invalidBankFeeText = "Accepted file format .pdf";
					}
					else if(!FileUtil.isFileNameValid(fileNameWithoutExtension,vm.maxFileNameLength )){
	    				 angular.element("input[type='file']").val(null);
	    				 vm.bankFee=null;
				         vm.inputBankFee=null;
				         vm.invalidBankFee = false;
				         vm.invalidBankFeeSize = false;
				         vm.invalidBankFeeName = true;
				         vm.invalidBankFeeNameText = "Uploaded pdf file name should not exceed " + vm.maxFileNameLength+ " charaters.";
				         
	    			 }

					else{ // check for malicious file with correct extension
						var reader = new FileReader();
						reader.readAsArrayBuffer(value.slice(0,4));
						reader.onloadend = function(e){
							if (e.target.readyState === FileReader.DONE) {
								var arrayBuffer = e.target.result;
								var bytes = new Uint8Array( arrayBuffer );
								if(!FileUtil.checkTermsConditionExtension(bytes)){
									angular.element("input[type='file']").val(null);
									vm.bankFee=null;
									vm.inputBankFee=null;
									vm.invalidBankFee = true;
									vm.invalidBankFeeSize = false;
									vm.invalidBankFeeName = false;
									vm.invalidBankFeeText = "Accepted file format .pdf";
								}
								else{
									vm.invalidBankFeeSize = false;
									vm.invalidBankFee =false;
									vm.invalidBankFeeName = false;


								}
								$scope.$digest();
							}
						}; 
					}
				}
			}
			else{
				angular.element("input[type='file']").val(null);
				
				vm.inputBankFee=null;
				
			}
		});
		
	        

	}   
})();
